import React, { useEffect } from 'react';
import { withAppContext } from 'src/store/initAppContext';
import styled, { css, withTheme } from 'styled-components';
import { theme } from 'styled-tools';
import config from 'src/config/config';

function PlaytechNewLaunchPromoFun88(props: any) {
    const { app: {
        brandId
    }, theme } = props;

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    const isPK = brandId && (brandId == 35 || brandId == 36 || brandId == 37 || brandId == 49);
    const winningAmount = (brandId == 61) ? "$100" : isPK ? "PKR 30,000" : "₹10,000";

    const terms = [
        <>Promotion is valid until <strong>31 May 2026</strong>.</>,
        <>Applicable only on the mentioned PlayTech launch games.</>,
        <>Promotion is valid once per player.</>,
        <>Available for the first <strong>10,000</strong> eligible players only.</>,
        <>Maximum winning per player: <strong>{winningAmount}</strong></>,
        <>Cash prizes are credited directly to the player's wallet.</>,
        <>PlayTech reserves the right to modify, suspend, or cancel the promotion at any time.</>,
        <>Eligible games or mechanics may change without prior notice.</>,
        <>General Casino Terms & Conditions apply. </>
    ];

    return (
        <>
            <InformationWrapper>
                <HeaderSection>
                    <SmallTitle>Playtech New Launch &#45; Win Big!</SmallTitle>

                    <MainTitle>
                        Celebrate the launch of PlayTech games and get a chance to win instant cash rewards. <br />
                        Place a single qualifying bet and win up to <strong>{winningAmount}</strong>
                    </MainTitle>
                </HeaderSection>

                <Container>
                    <SectionHeading>How To Claim</SectionHeading>
                    <ClaimGrid>
                        <BigCard>
                            <StepNumber>1</StepNumber>

                            <CardTextWrap>
                                <h3>Play Any</h3>
                                <p>of the launch games<br /> from <strong>PlayTech</strong>.</p>
                                <ul>
                                    <li>Mega Fire Blaze Roulette</li>
                                    <li>Adventures Beyond Wonderland Live</li>
                                </ul>
                            </CardTextWrap>
                        </BigCard>

                        <RightCards>
                            <SideCard $propsWinUpto>
                                <StepNumber>2</StepNumber>
                                <SideCardContent>
                                    <TextArea>
                                        <h3>Place at least</h3>
                                        <p>One cash bet on the game.</p>
                                    </TextArea>
                                </SideCardContent>
                            </SideCard>

                            <SideCard $propsGHigherBet>
                                <StepNumber>3</StepNumber>
                                <SideCardContent>
                                    <TextArea>
                                        <h3>Stand a chance</h3>
                                        <p>To win cash instantly — <strong>Up to {winningAmount}</strong></p>
                                    </TextArea>
                                </SideCardContent>
                            </SideCard>
                        </RightCards>
                    </ClaimGrid>
                </Container>

                <Container>
                    <TermsHeading>Terms & Conditions</TermsHeading>
                    <TermsList>
                        {terms.map((term, index) => (
                            <TermItem key={index}>
                                <span>✦</span>
                                <p>{term}</p>
                            </TermItem>
                        ))}
                    </TermsList>
                </Container>
            </InformationWrapper>

        </>
    );
}

export default withTheme(withAppContext(PlaytechNewLaunchPromoFun88));

const InformationWrapper = styled.div`
    width: 100%;
    height: auto;
    padding: 1rem 0 5rem 0;
    gap: 1.5rem;
    display: flex;
    flex-direction: column;
    align-items: center;
    overflow: hidden;
    color: #444;
    background-color: #EBEBEB;

    strong {
        color: #444;
        font-family: 'Inter-Bold';
    }
`;

const Container = styled.div`
    width: 80%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    background-color: #fff;
    padding: 1.5rem 1.5rem;
    border-radius: 8px;
`;

const HeaderSection = styled.div`
    width: 80%;
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    background-color: #fff;
    border-radius: 8px;
    position: relative;
    padding: 2rem 1rem;
`;

const SmallTitle = styled.p`
    margin: 0;
    color: #06A6FF;
    font-size: 18px;
    font-family: 'Inter-Bold';
    line-height: 1.2;
`;

const MainTitle = styled.h1`
    margin: 18px 0 0;
    color: #444;
    font-size: 15px;
    line-height: 1.45;
    font-family: 'Inter';
    letter-spacing: 0.3px;
    text-transform: uppercase;
    font-weight: 100;
`;

const SectionHeading = styled.h2`
    margin: 2rem 0 2rem;
    color: #06A6FF;
    font-size: 20px;
    font-family: 'Inter-Bold';
    text-align: center;
`;

const ClaimGrid = styled.div`
    width: 100%;
    max-width: 962px;
    display: grid;
    grid-template-columns: 1fr 1.9fr;
    gap: 16px;
    align-items: stretch;
    padding-bottom: 1rem;

    @media (max-width: 900px) {
        grid-template-columns: 1fr;
        padding: 0 1rem;
    }
`;

const StepNumber = styled.div`
    position: absolute;
    top: 28px;
    left: 18px;
    width: 34px;
    height: 34px;
    border-radius: 50%;
    border: 1px solid #444;
    background: #444;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 18px;
    z-index: 2;
    color: #fff;
`;

const GlassCard = `
    position: relative;
    border-radius: 15px;
    border: 1.5px solid rgb(148 148 148);
    backdrop-filter: blur(7.5px);
    overflow: hidden;
`;

const BigCard = styled.div`
    ${GlassCard};
    min-height: 352px;
    padding: 22px 22px 16px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    background: url(${config.imageV3Host}/static/cashsite/${theme("image.AviatorFreeBetsWthIPLBetsBetOneBg")}) #ebebeb;
    background-position: center;
    background-size: cover;
    background-repeat: no-repeat;
`;

const RightCards = styled.div`
    display: flex;
    flex-direction: column;
    gap: 18px;
`;

const SideCard = styled.div<{ $propsWinUpto?: boolean, $propsGHigherBet?: boolean }>`
    ${GlassCard};
    /* min-height: 96px; */
    padding: 18px 34% 18px 14px;
    display: flex;
    align-items: center;
    flex: auto;

    ${(props) => props.$propsWinUpto && css`
        background: url(${config.imageV3Host}/static/cashsite/${theme("image.PlaytechNewLaunchBonusPlaceAtleaseInnerBg")}) #ebebeb;
    `}

    ${(props) => props.$propsGHigherBet && css`
        background: url(${config.imageV3Host}/static/cashsite/${theme("image.PlaytechNewLaunchBonusStandAChanceInnerBg")}) #ebebeb;
    `}

    background-position: right;
    background-size: cover;
    background-repeat: no-repeat;

    ${StepNumber} {
        top: unset;
    }
`;

const CardTextWrap = styled.div`
    padding-left: 50px;
    padding-top: 4px;

    h3 {
        margin: 0 0 8px;
        font-size: 20px;
        font-family: 'Inter-Bold';
        color: #444;
    }

    p {
        margin: 0;
        color: #444;
        font-size: 16px;
        line-height: 1.45;
        font-weight: 600;
    }

    ul {
        padding-left: 17px;
        font-size: 15px;
        li {
            padding-bottom: 10px;
        }
    }
`;

const SideCardContent = styled.div`
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 18px;
    padding-left: 58px;
`;

const TextArea = styled.div`
    h3 {
        margin: 0 0 6px;
        font-size: 18px;
        font-family: 'Inter-Bold';
        color: #444;
    }

    p {
        margin: 0;
        color: #444;
        font-size: 16px;
        line-height: 1.35;
        font-weight: 500;
    }
`;

const TermsHeading = styled.h2`
    margin: 2rem 0 2rem;
    color: #06A6FF;
    font-size: 20px;
    font-family: 'Inter-Bold';
    text-align: center;
`;

const TermsList = styled.ul`
    width: 100%;
    max-width: 545px;
    list-style: none;
    margin: 0;
    padding: 0;
    display: flex;
    flex-direction: column;
    border-radius: 7px;
    background: #EBEBEB;
    gap: 18px;
    padding: 2rem;
`;

const TermItem = styled.li`
    width: 100%;
    display: flex;
    align-items: flex-start;
    gap: 3px;
    box-sizing: border-box;
    text-transform: capitalize;

    span {
        color: #444;
        font-size: 14px;
        flex: 0 0 16px;
        margin-top: 1px;
    }

    p {
        margin: 0;
        color: #444;
        font-size: 16px;
        line-height: 1.35;
        font-weight: 500;
    }
`;